import { EyeIcon, XIcon, StarIcon } from "@heroicons/react/outline";
import {
  ButtonBase,
  TwoColumnSectionBase,
  ImageOverlay,
  ModalBase,
  BadgeBase,
} from "@reusejs/react";
import {
  amountFormatter,
  getWatermarkedImgixUrl,
  shortlistProperty,
} from "services";
import { useRouter } from "next/router";
import { DateTime } from "luxon";
import { useSelector } from "react-redux";
import InterestModalComponent from "../propertyDetail/InterestModal";
import InterestForm from "../propertyDetail/InterestForm";
import BlueIcon from "../../Icons/BlueIcon";
import GreenIcon from "../../Icons/GreenIcon";

export interface PropertyCardProps {
  onClick?: any;
  borderClasses?: any;
  top?: boolean;
  widthClasses?: any;
  property: any;
}

export default function ShortlistedPropertyCard(props: PropertyCardProps) {
  return (
    <TwoColumnSectionBase
      firstColumnEl={<Image {...props} />}
      secondColumnEl={
        <TwoColumnSectionBase
          firstColumnEl={<Content {...props} />}
          secondColumnEl={<Action {...props} />}
          twoColumnSectionBaseClasses={{
            firstElWrapperStyles: "md:w-3/5",
            secondElWrapperStyles: "w-full md:w-2/5 border-l self-stretch p-4",
            columnsFlexWrapperStyles:
              "flex sm:items-start justify-between flex-col md:flex-row",
          }}
        />
      }
      twoColumnSectionBaseClasses={{
        firstElWrapperStyles: "w-full md:w-1/4 md:h-[251px] overflow-hidden",
        secondElWrapperStyles: "w-full md:w-3/4 self-stretch",
        columnsFlexWrapperStyles:
          "flex mb-7 md:mb-0 items-start justify-between border shadow rounded-lg flex-col md:flex-row",
      }}
    />
  );
}
const Image = (props: any) => {
  return (
    <div className="relative rounded-t-lg sm:rounded-tr-none sm:rounded-l-lg overflow-hidden">
      {props.property?.images && props.property?.images.length > 0 ? (
        <>
          {/* web */}
          <div className="hidden md:block">
            <ImageOverlay
              src={`${process.env.NEXT_PUBLIC_IMAGIX_URL}/${props.property?.images[0].key_path}?fit=crop&w=224&h=251&auto=format`}
              width={224}
              height={251}
              placeholderSrc={
                props.property?.asset?.name === "residential"
                  ? getWatermarkedImgixUrl(
                      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/5f5054dc-b5b5-44c8-8c0e-e90b981f17de?fit=crop&w=224&h=251&auto=format`,
                    )
                  : props.property?.asset?.name === "commercial"
                  ? getWatermarkedImgixUrl(
                      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/1d41376d-0203-4311-9533-40198e5f8c35?fit=crop&w=224&h=251&auto=format`,
                    )
                  : getWatermarkedImgixUrl(
                      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/96512031-3c35-47ae-bbf3-757336f15530?fit=crop&w=224&h=251&auto=format`,
                    )
              }
              topLeft={
                <BadgeBase
                  label={props.property?.asset?.name}
                  badgeBaseClasses={{
                    padding: "px-2 py-0.5",
                    backgroundColor:
                      props.property?.asset?.name === "residential"
                        ? "bg-green-100"
                        : props.property?.asset?.name === "commercial"
                        ? "bg-red-100"
                        : "bg-yellow-100",
                    textColor:
                      props.property?.asset?.name === "residential"
                        ? "text-green-800"
                        : props.property?.asset?.name === "commercial"
                        ? "text-red-800"
                        : "text-yellow-800",
                    font: "text-xs font-small",
                    borderRadius: "rounded-md",
                  }}
                />
              }
              topRight={
                <StarIcon
                  width="24"
                  height="24"
                  className="text-yellow-300"
                  fill="currentColor"
                />
              }
            />
          </div>
          {/* Mobile */}
          <div className="block md:hidden">
            <ImageOverlay
              src={`${process.env.NEXT_PUBLIC_IMAGIX_URL}/${props.property?.images[0].key_path}?fit=crop&w=224&h=251&auto=format`}
              width={290}
              height={251}
              placeholderSrc={
                props.property?.asset?.name === "residential"
                  ? getWatermarkedImgixUrl(
                      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/5f5054dc-b5b5-44c8-8c0e-e90b981f17de?fit=crop&w=224&h=251&auto=format`,
                    )
                  : props.property?.asset?.name === "commercial"
                  ? getWatermarkedImgixUrl(
                      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/1d41376d-0203-4311-9533-40198e5f8c35?fit=crop&w=224&h=251&auto=format`,
                    )
                  : getWatermarkedImgixUrl(
                      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/96512031-3c35-47ae-bbf3-757336f15530?fit=crop&w=224&h=251&auto=format`,
                    )
              }
              topLeft={
                <BadgeBase
                  label={props.property?.asset?.name}
                  badgeBaseClasses={{
                    padding: "px-2 py-0.5",
                    backgroundColor:
                      props.property?.asset?.name === "residential"
                        ? "bg-green-100"
                        : props.property?.asset?.name === "commercial"
                        ? "bg-red-100"
                        : "bg-yellow-100",
                    textColor:
                      props.property?.asset?.name === "residential"
                        ? "text-green-800"
                        : props.property?.asset?.name === "commercial"
                        ? "text-red-800"
                        : "text-yellow-800",
                    font: "text-xs font-small",
                    borderRadius: "rounded-md",
                  }}
                />
              }
              topRight={
                <StarIcon
                  width="24"
                  height="24"
                  className="text-yellow-300"
                  fill="currentColor"
                />
              }
            />
          </div>
        </>
      ) : (
        <>
          {/* web */}
          <div className="hidden md:block">
            <ImageOverlay
              src={
                props.property?.asset?.name === "residential"
                  ? getWatermarkedImgixUrl(
                      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/5f5054dc-b5b5-44c8-8c0e-e90b981f17de?fit=crop&w=224&h=251&auto=format`,
                    )
                  : props.property?.asset?.name === "commercial"
                  ? getWatermarkedImgixUrl(
                      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/1d41376d-0203-4311-9533-40198e5f8c35?fit=crop&w=224&h=251&auto=format`,
                    )
                  : getWatermarkedImgixUrl(
                      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/96512031-3c35-47ae-bbf3-757336f15530?fit=crop&w=224&h=251&auto=format`,
                    )
              }
              width={224}
              height={251}
              topLeft={
                <BadgeBase
                  label={props.property?.asset?.name}
                  badgeBaseClasses={{
                    padding: "px-2 py-0.5",
                    backgroundColor:
                      props.property?.asset?.name === "residential"
                        ? "bg-green-100"
                        : props.property?.asset?.name === "commercial"
                        ? "bg-red-100"
                        : "bg-yellow-100",
                    textColor:
                      props.property?.asset?.name === "residential"
                        ? "text-green-800"
                        : props.property?.asset?.name === "commercial"
                        ? "text-red-800"
                        : "text-yellow-800",
                    font: "text-xs font-small",
                    borderRadius: "rounded-md",
                  }}
                />
              }
              topRight={
                <StarIcon
                  width="24"
                  height="24"
                  className="text-yellow-300"
                  fill="currentColor"
                />
              }
              altName={
                props.property?.asset?.name === "residential"
                  ? "residential-auction-property"
                  : props.property?.asset?.name === "commercial"
                  ? "commercial-auction-property"
                  : "industrial-auction-property"
              }
            />
          </div>
          {/* mobile */}
          <div className="block md:hidden">
            <ImageOverlay
              src={
                props.property?.asset?.name === "residential"
                  ? getWatermarkedImgixUrl(
                      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/5f5054dc-b5b5-44c8-8c0e-e90b981f17de?fit=crop&w=224&h=251&auto=format`,
                    )
                  : props.property?.asset?.name === "commercial"
                  ? getWatermarkedImgixUrl(
                      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/1d41376d-0203-4311-9533-40198e5f8c35?fit=crop&w=224&h=251&auto=format`,
                    )
                  : getWatermarkedImgixUrl(
                      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/96512031-3c35-47ae-bbf3-757336f15530?fit=crop&w=224&h=251&auto=format`,
                    )
              }
              width={290}
              height={251}
              topLeft={
                <BadgeBase
                  label={props.property?.asset?.name}
                  badgeBaseClasses={{
                    padding: "px-2 py-0.5",
                    backgroundColor:
                      props.property?.asset?.name === "residential"
                        ? "bg-green-100"
                        : props.property?.asset?.name === "commercial"
                        ? "bg-red-100"
                        : "bg-yellow-100",
                    textColor:
                      props.property?.asset?.name === "residential"
                        ? "text-green-800"
                        : props.property?.asset?.name === "commercial"
                        ? "text-red-800"
                        : "text-yellow-800",
                    font: "text-xs font-small",
                    borderRadius: "rounded-md",
                  }}
                />
              }
              topRight={
                <StarIcon
                  width="24"
                  height="24"
                  className="text-yellow-300"
                  fill="currentColor"
                />
              }
              altName={
                props.property?.asset?.name === "residential"
                  ? "residential-auction-property"
                  : props.property?.asset?.name === "commercial"
                  ? "commercial-auction-property"
                  : "industrial-auction-property"
              }
            />
          </div>
        </>
      )}
    </div>
  );
};

const Content = (props: any) => {
  const current_date_object = DateTime.now().setZone("Asia/Kolkata").set({
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  });
  const emd_last_date_object = DateTime.fromISO(
    props.property.emd_last_date && props.property.emd_last_date,
  ).setZone("Asia/Kolkata");
  const diffDays = Math.floor(
    emd_last_date_object.diff(current_date_object, "days").days,
  );

  return (
    <div className="w-full">
      <div className="text-left px-4 py-2 border-b text-xs text-gray-500">
        Assets ID: {props.property?.listing_id}
      </div>
      <div className="text-left border-b px-4 py-4 flex justify-between h-20">
        <div className="flex basis-1/2 flex-col">
          <div className="text-xs text-gray-500">
            {props.property?.city?.name}
          </div>
          <div className="text-sm">{props.property?.state?.name}</div>
        </div>
        <div className="flex basis-1/2 flex-col pl-6">
          <div>
            {props.property?.bank?.name && (
              <div className="text-xs flex items-center text-gray-500">
                <BlueIcon /> {props.property?.bank?.name}
              </div>
            )}
            {props.property?.ab_verified && (
              <div className="text-xs flex items-center text-blue-600">
                <GreenIcon />
                Verified by Auction Bazaar
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="text-left border-b px-4 flex justify-between">
        <div className="flex basis-1/2 border-r py-4 flex-col">
          <div className="text-xs text-gray-500">Auction Date</div>
          <div className="text-sm">
            {" "}
            {props.property.property_date_type === "undated" ? (
              <span className="text-red-600">Coming Soon</span>
            ) : props.property.property_date_type === "private_treaty" ? (
              <span className="text-green-600">Private Treaty</span>
            ) : (
              props.property?.auction_start_date_time &&
              DateTime.fromISO(props.property?.auction_start_date_time)
                .setZone("Asia/Kolkata")
                .toFormat("dd MMMM yyyy")
            )}
          </div>
        </div>
        <div className="flex basis-1/2 py-4 flex-col pl-6">
          <div className="text-xs text-gray-500">EMD Amount</div>
          <div className="text-sm">
            {props.property.property_date_type === "undated" ? (
              <span className="text-red-600">Coming Soon</span>
            ) : props.property.property_date_type === "private_treaty" ? (
              <span className="text-green-600">Private Treaty</span>
            ) : (
              `₹${amountFormatter(props.property?.emd_amount)}`
            )}
          </div>
        </div>
      </div>
      <div className="text-left border-b px-4 py-2 bg-gray-100 flex justify-between items-center">
        <div className="flex flex-col">
          <div className="text-xs text-[#575D68]">
            {`${
              props.property.interested_count === 0
                ? props.property.interested_count
                : props.property.interested_count + "+"
            } People are interested`}
          </div>
        </div>
        <div className="flex flex-col">
          <div className="flex items-center text-xs text-blue-600">
            <EyeIcon width="20" height="20" className="mr-1" />
            {`${
              props.property.view_count === 0
                ? props.property.view_count
                : props.property.view_count + "+"
            } Views`}
          </div>
        </div>
      </div>
      <div className="text-left px-4 py-2 bg-red-100 flex justify-between items-center">
        {props.property.property_date_type === "dated" ? (
          <div className="flex">
            {diffDays > 0 ? (
              <div className="text-xs text-[#C81E1E]">
                EMD Deposit ends in{" "}
                <span className="font-semibold">{diffDays} Days</span>!
              </div>
            ) : diffDays === 0 ? (
              <div className="text-xs text-[#C81E1E]">
                EMD Deposit ends <span className="font-semibold">Today</span>!
              </div>
            ) : (
              <div className="text-xs text-red-500">
                EMD deposit deadline has ended.
              </div>
            )}
          </div>
        ) : (
          <div className="flex">
            <div className="text-xs text-red-100">.</div>
          </div>
        )}
      </div>
    </div>
  );
};

const Action = (props: any) => {
  const router = useRouter();

  const userUuid = useSelector((state: any) => {
    return state.auth.user?.uuid;
  });
  const InterestModalWrapper = (propsA: any) => {
    return (
      <InterestModalComponent
        heading="Thanks for your interest"
        subHeading="Please select a date and time for a detail call with our property executives"
        description={
          <InterestForm
            {...propsA}
            property_uuid={props.property.uuid}
            listing_id={props.property.listing_id}
            user_uuid={userUuid ? userUuid : ""}
          />
        }
        router={router}
        {...propsA}
      />
    );
  };

  const openModal = async (modal: any) => {
    await ModalBase({
      content: modal,
      timeout: 0,
      backgroundColor: "bg-black/30",
      backgroundOpacity: "opacity-70",
      modalBaseClasses: {
        background: "bg-white",
        border: "border-2 rounded-lg",
        alignment: "z-50 overflow-visible",
        padding: "p-0",
        small: "max-w-4xl",
      },
    });
  };

  const handleRemove = async (uuid: any) => {
    try {
      await shortlistProperty(uuid, props.property.interested_count);
    } catch (error) {
      console.log("check error", error);
    }
  };

  return (
    <div className="flex flex-col h-full justify-between">
      <div>
        <div className="flex justify-end">
          <XIcon
            onClick={() => handleRemove(props.property.uuid)}
            className="h-4 w-4 text-semibold cursor-pointer text-gray-500 hover:text-blue-600"
          />
        </div>
        <div className="text-left flex justify-between">
          <div className="flex basis-1/2 flex-col">
            <div className="text-base text-gray-500">Reserve Price</div>
            <div className="text-2xl font-bold text-blue-600">
              {props.property.property_date_type === "undated" ? (
                <div
                  className="cursor-pointer text-xl hover:text-blue-700"
                  onClick={() => {
                    const baseurl = window.location.href
                      .split("/")
                      .filter(Boolean)[1];
                    const link =
                      "https://" +
                      baseurl +
                      "/auction-properties/" +
                      props.property.listing_id;

                    window.open(
                      `https://wa.me/918370969696?text=${encodeURI(
                        `Hello, I would like to know the price of this property: ${link}`,
                      )}`,
                      "_blank",
                    );
                  }}
                >
                  Contact Us
                </div>
              ) : (
                `₹${amountFormatter(props.property?.reserve_price)}`
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="space-y-4 mt-1 md:mt-0">
        <ButtonBase
          variant="primary"
          type="submit"
          label={"Know More"} //{"Start Bidding"}
          onClick={() => {
            openModal(InterestModalWrapper);
          }}
          buttonBaseClasses={{
            font: "text-sm md:text-base font-semibold md:font-medium",
            backgroundColor: "bg-blue-600 hover:bg-blue-700",
            textColor: "text-white",
            border: "any",
            width: "w-full",
            padding: "px-4 py-3",
          }}
        />
        <ButtonBase
          variant="primary"
          type="submit"
          label={"View Detail"}
          onClick={
            () => {
              const newTab: any = window.open(
                `/auction-properties/${props.property?.listing_id}`,
                `_blank`,
              );
              newTab.focus();
            }
            // router.push(`/auction-properties/${props.property?.listing_id}`)
          }
          buttonBaseClasses={{
            font: "text-sm md:text-base font-semibold md:font-medium",
            backgroundColor: "bg-transparent",
            textColor: "text-gray-900 hover:text-blue-600",
            border: "border border-gray-900 hover:border-blue-600",
            width: "w-full",
            padding: "px-4 py-3",
          }}
        />
      </div>
    </div>
  );
};
